import * as React from 'react';

import { getAppStore } from '~src/bootstrap/redux/store/AppStore';
import { Messages } from '~src/codegen/Localize';
import { FlowDraftBanner } from '~src/flow/components/FlowDraftBanner';
import { WarningBanner } from '~src/flow/components/header/WarningBanner';
import { ISpaceItemDetailInfo } from '~src/spacesPlatform/models/ISpaceItemDetailInfo';
import { cssClass } from '~src/style';

import {
  CompositeSessionInfoSelectors, SessionServerSelectors,
  SessionSiteSelectors
} from '../../bootstrap/redux/selectors/SessionInfoSelectors';
import { areFlowParametersEnabled, containsAnyTypeParameter } from '../utils/FlowParametersUtils';

const rootClass = 'FlowSpaceBanner';

const bannerWrapper = cssClass(rootClass, 'bannerWrapper', {
  $nest: {
    '& > div:not(:first-of-type)': {
      marginTop: 16,
    }
  }
});

export interface FlowSpaceBannerProps {
  readonly item: ISpaceItemDetailInfo<'flow'>;
}

export function FlowSpaceBanner(props: FlowSpaceBannerProps) {
  const state = getAppStore().getState();
  const shouldShowDraftBanner = props.item && props.item.flowDraft;
  const shouldShowFlowParameterNotEnabledBanner = !areFlowParametersEnabled() && props.item.containsParameters;
  const userIsAdmin = CompositeSessionInfoSelectors.currentUserIsSiteOrServerAdminSelector(state);
  const shouldShowFlowParametersAnySettingNotEnabledBanner =
    areFlowParametersEnabled() &&
    !SessionSiteSelectors.flowParametersAnyTypeEnabled(state) &&
    containsAnyTypeParameter(props.item.relevantParameters || []);
  const shouldShowFlowsDisabledByEmbeddedSetting =
    !userIsAdmin &&
    !SessionServerSelectors.schedulingEnabled(state);
  const shouldShowRunNowDisabled = !userIsAdmin && !CompositeSessionInfoSelectors.isRunNowEnabled(state);
  const shouldShowNoOutputStepBanner = props.item.outputCount <= 0;

  let tooltipMessages = [];

  if (shouldShowFlowParameterNotEnabledBanner) {
    tooltipMessages.push(Messages.flowParametersNotEnabledBannerDescription());
  }

  if (shouldShowFlowParametersAnySettingNotEnabledBanner) {
    tooltipMessages.push(Messages.flowParametersAnySettingNotEnabledBannerDescription());
  }

  if (shouldShowFlowsDisabledByEmbeddedSetting) {
    tooltipMessages.push(Messages.flowSchedulingDisabledByEmbeddedCredsSetting());
  }

  if (shouldShowRunNowDisabled) {
    tooltipMessages.push(Messages.flowRunNowDisabled());
  }

  if (shouldShowNoOutputStepBanner) {
    tooltipMessages.push(Messages.flowHasNoOutputSteps());
  }

  return (
    <div className={bannerWrapper}>
      { shouldShowDraftBanner ? <FlowDraftBanner flow={props.item} /> : null }
      { tooltipMessages.length > 0 ? <WarningBanner message={ Messages.flowCannotBeRun() } tooltipMessages={ tooltipMessages } />: null }
    </div>
  );
}
